import { api } from '@/lib/api';
import type { SupportRequest } from './types';

/** Which side of the app is calling — customer (`/user`) or vendor (`/vendor`). */
export type Side = 'user' | 'vendor';

export async function fetch_my_support_requests(side: Side): Promise<SupportRequest[]> {
  const res = await api.get<SupportRequest[]>(`/${side}/support-requests`);
  return res.data;
}

/** Raise an admin support request on a booking (kind derived server-side from the module). */
export async function open_support_request(side: Side, booking_id: string, reason?: string): Promise<SupportRequest> {
  const res = await api.post<SupportRequest>(`/${side}/bookings/${booking_id}/support`, reason ? { reason } : {});
  return res.data;
}

/** Agree to the admin-proposed reschedule slot (trainer flow; applies once both sides agree). */
export async function agree_support_request(side: Side, booking_id: string): Promise<SupportRequest> {
  const res = await api.post<SupportRequest>(`/${side}/bookings/${booking_id}/support/agree`);
  return res.data;
}
